import React, { useEffect, useState } from 'react';
import ClientDetailModal from './ClientDetailModal';
import CreateClientModal from './CreateClientModal';

const ClientsPage = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  // Fetch clients from backend
  const fetchClients = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/get-clients.php');
      const data = await res.json();
      setClients(data.clients || []);
    } catch (err) {
      setError('Failed to load clients.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchClients();
  }, []);

  // Add client
  const handleCreateClient = async (clientData) => {
    const res = await fetch('/api/add-client.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(clientData)
    });
    if (!res.ok) throw new Error('Failed to add client');
    await fetchClients();
  };

  // Edit client
  const handleEditClient = async (clientId, editData) => {
    const res = await fetch('/api/edit-client.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clientId, ...editData })
    });
    if (!res.ok) throw new Error('Failed to edit client');
    await fetchClients();
  };

  // Delete client
  const handleDeleteClient = async (clientId) => {
    const res = await fetch('/api/delete-client.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clientId })
    });
    if (!res.ok) throw new Error('Failed to delete client');
    await fetchClients();
  };

  return (
    <div style={{ padding: 'var(--section-padding)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h2 style={{ color: 'var(--color-primary)', fontSize: '2rem', fontWeight: 700 }}>Clients</h2>
        <button
          style={{
            background: 'var(--color-primary)',
            color: 'var(--color-text-inverse)',
            border: 'none',
            borderRadius: 'var(--border-radius)',
            padding: '0.5rem 1.5rem',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: 'var(--box-shadow)'
          }}
          onClick={() => setShowCreateModal(true)}
        >
          + Add Client
        </button>
      </div>
      {loading ? (
        <div>Loading clients...</div>
      ) : error ? (
        <div style={{ color: 'var(--color-error)' }}>{error}</div>
      ) : (
        <div style={{ background: 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--color-bg-alt)' }}>
                <th style={{ padding: '1rem', textAlign: 'left', color: 'var(--color-text-light)' }}>Name</th>
                <th style={{ padding: '1rem', textAlign: 'left', color: 'var(--color-text-light)' }}>Contact Person</th>
                <th style={{ padding: '1rem', textAlign: 'left', color: 'var(--color-text-light)' }}>Email</th>
                <th style={{ padding: '1rem', textAlign: 'left', color: 'var(--color-text-light)' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {clients.length === 0 ? (
                <tr><td colSpan={4} style={{ padding: '2rem', textAlign: 'center', color: 'var(--color-text-light)' }}>No clients found.</td></tr>
              ) : (
                clients.map(client => (
                  <tr key={client.id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                    <td style={{ padding: '1rem', color: 'var(--color-text)' }}>{client.name}</td>
                    <td style={{ padding: '1rem', color: 'var(--color-text)' }}>{client.contactPerson}</td>
                    <td style={{ padding: '1rem', color: 'var(--color-text)' }}>{client.email}</td>
                    <td style={{ padding: '1rem' }}>
                      <button
                        style={{ background: 'var(--color-secondary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.25rem 1rem', marginRight: 8, cursor: 'pointer' }}
                        onClick={() => setSelectedClient(client)}
                      >
                        View / Edit
                      </button>
                      <button
                        style={{ background: 'var(--color-error)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.25rem 1rem', cursor: 'pointer' }}
                        onClick={() => handleDeleteClient(client.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
      {showCreateModal && (
        <CreateClientModal
          onClose={() => setShowCreateModal(false)}
          onCreateClient={handleCreateClient}
        />
      )}
      {selectedClient && (
        <ClientDetailModal
          client={selectedClient}
          onClose={() => setSelectedClient(null)}
          onEditClient={handleEditClient}
          onDeleteClient={handleDeleteClient}
        />
      )}
    </div>
  );
};

export default ClientsPage; 